<template>
  <b-card>
    <ListConcedenteContatos :concedente_id="concedente.id" />
  </b-card>
</template>

<script>
import ListConcedenteContatos from "@/modules/concedentes_contatos/pages/List.vue";
import { mapState } from "vuex";

export default {
  components: { ListConcedenteContatos },
  computed: {
    ...mapState("concedentes", ["concedente"]),
  },
};
</script>
